import { EntityGrid } from "@serenity-is/corelib";
import { cast, Router } from "@serenity-is/corelib/q";

var orgCreateSlickContainer = EntityGrid.prototype["createSlickContainer"];
EntityGrid.prototype["createSlickContainer"] = function () {

    this.element.addClass('route-handler')
        .off('handleroute.' + this.uniqueName)
        .on('handleroute.' + this.uniqueName, (e: JQueryEventObject, arg: any) => {
            if (!!arg.handled)
                return;

            if (!!(arg.route === 'new')) {
                arg.handled = true;
                this.addButtonClick();
                return;
            }

            var oldRequests = jQuery["active"];

            var parts = arg.route.split('/');
            if (!!(parts.length === 2 && parts[0] === 'edit')) {
                arg.handled = true;
                this.editItem(decodeURIComponent(parts[1]));
            }
            else if (!!(parts.length === 2 && parts[1] === 'new')) {
                arg.handled = true;
                this.editItemOfType(cast(parts[0], String), null);
            }
            else if (!!(parts.length === 3 && parts[1] === 'edit')) {
                arg.handled = true;
                this.editItemOfType(cast(parts[0], String), decodeURIComponent(parts[2]));
            }
            else
                return;

            if (jQuery["active"] > oldRequests && arg.handled && arg.index >= 0 && arg.index < arg.parts.length - 1) {
                $(document).one('ajaxStop', () => {
                    setTimeout(() => Router.resolve('#' + arg.parts.join('/+/')), 1);
                });
            }

        });

    return orgCreateSlickContainer.apply(this);
};
